import { SWRConfig } from "swr";
import BlogDetails from '@/src/components/blogs/BlogDetails';
import fetchAPI from "@/components/fetchAPI";

export async function getServerSideProps(context) {
  const { params } = context;
  const { id } = params;

  const queryKey = `/api/blog-posts/${id}/`;
  const blog = await fetchAPI(queryKey, {}, context);

  if (!blog?.id) {
    return {
      notFound: true
    }
  }

  return {
    props: {
      id,
      fallback: {
        [queryKey]: blog,
      }
    }
  }
}

export default function Index({ fallback, id }) {
  return (
    <SWRConfig value={{ fallback }}>
      <section className="section">
        <BlogDetails blogId={id} />
      </section>
    </SWRConfig>
  )
}